import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-300e0df4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "solution-detail-header"
};
const _hoisted_2 = {
  class: "solution-detail-header-content"
};
const _hoisted_3 = {
  class: "solution-detail-header-content__bd"
};
const _hoisted_4 = ["src", "alt"];
const _hoisted_5 = {
  class: "footnote"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "技术支持：chuhaiyi@baidu.com", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _ctx$currentSku, _ctx$data2, _ctx$data3, _ctx$data4;
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");
  const _component_header_info = _resolveComponent("header-info");
  const _component_el_drawer = _resolveComponent("el-drawer");
  const _component_client_only = _resolveComponent("client-only");
  const _component_customized_form_dialog = _resolveComponent("customized-form-dialog");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("section", _hoisted_2, [_createVNode(_component_el_breadcrumb, {
    "separator-class": "el-icon-arrow-right"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_breadcrumb_item, {
      to: {
        path: '/'
      }
    }, {
      default: _withCtx(() => [_createTextVNode("解决方案")]),
      _: 1
    }), _createVNode(_component_el_breadcrumb_item, null, {
      default: _withCtx(() => {
        var _ctx$data;
        return [_createTextVNode(_toDisplayString((_ctx$data = _ctx.data) === null || _ctx$data === void 0 ? void 0 : _ctx$data.spu_name), 1)];
      }),
      _: 1
    })]),
    _: 1
  }), _createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
    src: (_ctx$currentSku = _ctx.currentSku) === null || _ctx$currentSku === void 0 ? void 0 : _ctx$currentSku.logo,
    alt: (_ctx$data2 = _ctx.data) === null || _ctx$data2 === void 0 ? void 0 : _ctx$data2.spu_name,
    width: "328",
    class: "logo"
  }, null, 8, _hoisted_4), _createVNode(_component_header_info, {
    "spu-detail": _ctx.data,
    "current-sku": _ctx.currentSku,
    onSetDialog: _ctx.setDialog
  }, null, 8, ["spu-detail", "current-sku", "onSetDialog"]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", null, "更新时间：" + _toDisplayString((_ctx$data3 = _ctx.data) !== null && _ctx$data3 !== void 0 && _ctx$data3.updated_at ? _ctx.timeStampFormat((_ctx$data4 = _ctx.data) === null || _ctx$data4 === void 0 ? void 0 : _ctx$data4.updated_at) : '-'), 1), _hoisted_6])]), _createVNode(_component_client_only, null, {
    default: _withCtx(() => [_createVNode(_component_el_drawer, {
      modelValue: _ctx.drawerVisible,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.drawerVisible = $event),
      "modal-class": "sticky-drawer",
      "show-close": false,
      modal: false,
      "with-header": false,
      "lock-scroll": false,
      "append-to-body": false,
      direction: "ttb",
      size: "96px"
    }, {
      default: _withCtx(() => [_createVNode(_component_header_info, {
        "spu-detail": _ctx.data,
        "current-sku": _ctx.currentSku,
        "is-row-direction": true,
        onSetDialog: _ctx.setDialog
      }, {
        default: _withCtx(() => [_createVNode(_component_el_breadcrumb, {
          "separator-class": "el-icon-arrow-right"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_breadcrumb_item, {
            to: {
              path: '/'
            }
          }, {
            default: _withCtx(() => [_createTextVNode("解决方案")]),
            _: 1
          }), _createVNode(_component_el_breadcrumb_item, null, {
            default: _withCtx(() => {
              var _ctx$data5;
              return [_createTextVNode(_toDisplayString((_ctx$data5 = _ctx.data) === null || _ctx$data5 === void 0 ? void 0 : _ctx$data5.spu_name), 1)];
            }),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["spu-detail", "current-sku", "onSetDialog"])]),
      _: 1
    }, 8, ["modelValue"])]),
    _: 1
  })]), _createVNode(_component_customized_form_dialog, {
    "dialog-visible": _ctx.dialogVisible,
    "dialog-width": 504,
    "submit-form-data": _ctx.submitFormData,
    onSetDialog: _ctx.setDialog,
    onSubmitSuccess: _ctx.submitSuccess
  }, null, 8, ["dialog-visible", "submit-form-data", "onSetDialog", "onSubmitSuccess"])]);
}